import Vue from 'vue'

import { Button,
  Breadcrumb,
  BreadcrumbItem,
  Select,
  Tabs,
  TabPane,
  Table,
  TableColumn,
  Menu,
  MenuItem,
  MenuItemGroup,
  Submenu,
  Tree,
  Cascader,
  Dialog,
  Form,
  FormItem,
  Input,
  InputNumber,
  Card,
  Option,
  OptionGroup,
  Notification,
  Switch,
  Slider,
  Collapse,
  Message,
  Alert,
  CollapseItem,
  Loading,
  Tooltip,
  Row,
  Col,
  Tag,
  DatePicker,
  Radio,
  RadioButton,
  RadioGroup,
  Container,
  Header,
  Aside,
  Main,
  Footer
} from 'element-ui'
import lang from 'element-ui/lib/locale/lang/fr'
import locale from 'element-ui/lib/locale'

Vue.prototype.$ELEMENT = { size: 'small' }

Vue.use(Button)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Select)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Submenu)
Vue.use(Tree)
Vue.use(Cascader)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Card)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Switch)
Vue.use(Slider)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Loading.directive)
Vue.use(Tooltip)
Vue.use(Row)
Vue.use(Col)
Vue.use(Tag)
Vue.use(DatePicker)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Alert)
Vue.use(Tabs)
Vue.use(TabPane)

Vue.prototype.$notify = Notification
Vue.prototype.$loading = Loading.service
Vue.prototype.$message = Message

window.$notify = Notification

// configure language
locale.use(lang)
